module.exports = __webpack_public_path__ + "img/zx3.8537e8c8.png";